export const tiposUnidades =
    [
        {value:0, label:"Filial"},
        {value:1, label:"CD"},
        {value:2, label:"Unidade de negócio"},
    ]